module.exports = "<my-tables my-data=\"wagons\"\n  my-nature=\"'wagon'\"\n  disabled-list=\"true\">\n</my-tables>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/list/templates/home.html
// module id = 1547
// module chunks = 0